export default class ButtonGroupManager
{
    constructor(element)
    {
        this.element = element;
        this.eventDelegation();
    }

    eventDelegation()
    {
        this.element.querySelectorAll('[data-toggle="button"]').forEach((button) =>
        {
            button.addEventListener("click", (event) =>
            {
                let isActive = button.classList.contains('active');
                let selectHourButtons = this.element.querySelectorAll('[name="select-hour-button"].active');

                selectHourButtons.forEach(selectHourButton => {
                    selectHourButton.classList.remove('active');
                });

                if (!isActive && !this.hasClass(event.target, 'disabled')) {
                    $(event.target).addClass('active');
                }
            });
        });
    }

    hasClass(element, className) {
        return (' ' + element.className + ' ').indexOf(' ' + className + ' ') > -1;
    }
}